import { v4 as uuidv4 } from 'uuid';
import { ClientMagicAuthResponseDto, ClientOAuthCallbackResponseDto, ClientProfileDto } from '@/app/store/api/restApi';

export const AUTH_BROADCAST_CHANNEL = 'client-auth';
export const AUTH_BROADCAST_SOURCE_ID = uuidv4();

export enum AuthBroadcastMessageType {
  OAuthSuccess = 'OAUTH_SUCCESS',
  OAuthError = 'OAUTH_ERROR',
  MagicLinkSuccess = 'MAGIC_LINK_SUCCESS',
  EmailVerificationSuccess = 'EMAIL_VERIFICATION_SUCCESS',
}

export type AuthBroadcastMessage =
  | { type: AuthBroadcastMessageType.OAuthSuccess; payload: ClientOAuthCallbackResponseDto }
  | { type: AuthBroadcastMessageType.OAuthError }
  | {
      type: AuthBroadcastMessageType.MagicLinkSuccess;
      sourceId: string;
      payload: ClientMagicAuthResponseDto;
    }
  | {
      type: AuthBroadcastMessageType.EmailVerificationSuccess;
      sourceId: string;
      payload: ClientProfileDto;
    };
